import { useEffect, useRef } from 'react'

/**
 * execute callback on component unmount. callback is stabilized via a ref, so dont worry about a dependency array.
 *
 * @param {function} fn - callback to be executed on unmount
 */
export function useOnUnmount(fn) {
    const functionRef = useRef()
    functionRef.current = fn

    useEffect(() => () => typeof functionRef.current === 'function' && functionRef.current(), [])
}
